import React from "react";
import ForteDiv from "./ForteDiv";
import Footer from "./Footer";

const Forte = () => {
  return (
    <div className="absolute z-[999] flex flex-col items-center slide1 gap-10  min-w-full justify-around md:p-5   bg-[#fff7f1] overflow-hidden pb-0">
      <div className="flex flex-col items-center  w-full mt-[5rem]  ">
        <div className=" pb-[5rem] w-1/2">
          <h1 className="league-spartan-extrabold text-4xl md:text-6xl text-animate  text-center textanime      ">
            Here's how, I can help you{" "}
          </h1>
        </div>

        <ForteDiv
          topic="Web Development"
          intro="Develop custom websites and web applications that are fast, responsive, and secure."
        />
        <ForteDiv
          topic="Backend Development"
          intro="Robust backend Development services to power your web applications"
        />
        <ForteDiv
          topic="Optimization"
          intro="Enhancing the performance and efficiency of your web applications to ensure faster load times and a better user experience."
        />

        <ForteDiv
          topic="API Integration"
          intro="Seamlessly integrating third-party APIs to extend the functionality of your applications and streamline operations"
        />
      </div>

      <div className="  container py-40 px-1 sm:px-20 md:px-30 overflow-hidden min-w-screen ">
        <span className="  blob hidden md:inline-block absolute  right-0 w-[30%] h-[25%] blur-[100px] -z-10 opacity-20 bg-blue-500"></span>
        <div className="  lg:px-8 pb-8 rounded-3xl border border-black">
          <p className="inline-flex items-center text-md sm:px-4  bg-[#fff7f1] sm:text-lg font-bold -translate-y-4 text-blue-550 ">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              className="mr-2"
            >
              <circle cx="12" cy="12" r="10"></circle>
              <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
              <line x1="12" y1="17" x2="12.01" y2="17"></line>
            </svg>
            Are you hiring?
          </p>
          <article className="flex flex-col p-2 sm:p-4 justify-between  md:items-center md:p-12 rounded-3xl md:flex-row md:pr-16">
            <div className="  md:max-w-lg justify-center text-center flex flex-col items-center">
              <p className="mb-8 text-xl sm:text-2xl md:text-4xl lg:text-5xl font-bold">
                I'm looking for
                <br /> a new role!
              </p>
              <p className="text-md lg:text-lg max-w-[80%] lg:w-full">
                I'm looking to apply my skills with modern web development
                technologies (such as Next.js, Nodejs, Tailwind Css etc.) in a
                new role.
              </p>
              <p className="mt-2 text-md lg:text-lg max-w-[80%] lg:w-full">
                Interested or want to get to know me a bit better?
              </p>
            </div>
            <div className="mt-8 md:mt-0">
              <a
                href="https://www.linkedin.com/in/hemil-dudhat-52ab51265/"
                className=" scale-75 md:scale-100 inline-flex items-center justify-center w-full px-6 py-3 mb-4 text-xl font-bold text-center text-white  transition bg-black  rounded-lg md:justify-start md:w-auto hover:opacity-90 transform-gpu hover:-translate-y-1"
              >
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
                    <rect x="2" y="9" width="4" height="12"></rect>
                    <circle cx="4" cy="4" r="2"></circle>
                  </svg>
                </div>
                <div>
                  <span className="ml-2 pt-2 text-center align-top">
                    Get in Touch
                  </span>
                </div>
              </a>
              <p>
                Prefer email?
                <br />
                You can reach out to me
                <br />
                at hemildudhat36@gmail.com
              </p>
            </div>
          </article>
        </div>
      </div>
    <div className=" absolute bottom-0 w-full">

      <Footer />
    </div>
    </div>
  );
};

export default Forte;
